<script>
    import {onDestroy, onMount} from "svelte";
    import Menu from "./Menu/Menu.svelte";
    import Explorer from "./Explorer/Explorer.svelte";
    import API from "../../class/API";
    import { t } from "../../i18n";

    export let path = '';
    export let menus = [];
    export let showFolders = true;

    let divManager; onMount(() => divManager.dispatchEvent(new CustomEvent('init', {bubbles: true})));
    let comMenu;
    let comExplorer;
    let comExplorerSearch;

    let onChangeFolder = e => trigger('changeFolder', e.detail);

    $: error = null;
    $: content = null;
    $: loading = true;

    update();
    let timer = setInterval(()=>update(), 10000);
    onDestroy(()=>clearInterval(timer));

    // ------------------------------------------
    export function clear(){
        content = [];
    }
    export function update(){
        API('notes.files.list', {path})
            .then(data => {if(error)error=null; content = data; trigger('data', data);})
            .catch(err => error = err)
            .finally(() => loading = false);
    }
    export function retry(){
        error = null;
        loading = true;
        update();
    }
    export function send(msg){
        if(!msg||!msg.trim())return;
        return API('notes.post', {path, msg}).finally(update);
    }
    export function set_menu(data){ menus = data; }
    export function set_path(data){ path = data; update(); }


    let eventsCallback = [];
    export function on(action, fn){ eventsCallback.push({action, fn}); }
    export function trigger(action, args){ eventsCallback.filter(o=>o.action===action).forEach(o=>o.fn && o.fn(args)); }
</script>


<div class="file-manager-application" bind:this={divManager}>
    <div class="content-area-wrapper" style="margin:0 !important;">

        <Menu {menus} bind:this={comMenu} on:changeFolder={onChangeFolder}></Menu>

        <div class="content-right" style="width:100%;">
            <div class="content-overlay"></div>
            <div class="content-wrapper">
                <div class="content-header row"></div>
                <div class="content-body">
                    <div class="app-file-overlay"></div>
                    <div class="app-file-area">

                        <!-- <ExplorerSearch bind:this={comExplorerSearch}></ExplorerSearch> -->

                        {#if error}
                            <div style="padding:8px;">{$t('files.error')} {error}</div>
                        {:else if loading}
                            <div style="padding:8px;">{$t('files.loading')}</div>
                        {:else}
                            <Explorer bind:this={comExplorer} {content} {path}></Explorer>
                        {/if}

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
